import axios from "axios";

import { getQueryString } from "../resources/utils";

const {
  REACT_APP_API_URL,
} = process.env;
// Api Call for run avm

export function runPreFlightAvm(data) {
  const apiUrl = `${REACT_APP_API_URL}pre-flight-run-consumer-avm`;
  return axios.post(apiUrl, data);
}
export function runAvm(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}consumer-avm?${queryString}`;
  return axios.get(apiUrl);
}
export function getProjectData(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}project-data?${queryString}`;
  return axios.get(apiUrl);
}

// track activity
export function trackActivity(data) {
  const apiUrl = `${REACT_APP_API_URL}activity-tracker`;
  return axios.post(apiUrl, data);
}

//Get valuation price range for no of transactions
export function fetchValPriceRange(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}market-data-highest-lowest-end?${queryString}`;
  return axios.get(apiUrl);
}

//authentication by company or user tokens
export function doAuthenticate(data) {
  const apiUrl = `${REACT_APP_API_URL}authenticate-user`;
  return axios.post(apiUrl, data);
}

//Get feedback options
export function getFeedbackOptions(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}feedback-options?${queryString}`;
  return axios.get(apiUrl);
}

//post feedback
export function postFeedback(data) {
  const apiUrl = `${REACT_APP_API_URL}feedback`;
  return axios.post(apiUrl, data);
}
//generate otp
export function generateOtp(data) {
  const apiUrl = `${REACT_APP_API_URL}generate-consumer-user-otp`;
  return axios.post(apiUrl, data);
}

//verify user
export function verifyUser(queryParams) {
  const queryString = queryParams ? getQueryString(queryParams) : "";
  const apiUrl = `${REACT_APP_API_URL}verify-consumer-user?${queryString}`;
  return axios.get(apiUrl);
}
//verify otp
export function verifyConsumerOtp(data) {
  const apiUrl = `${REACT_APP_API_URL}verify-consumer-otp`;
  return axios.post(apiUrl, data);
}
//request for payment
export function requestPayment(data) {
  const apiUrl = `${REACT_APP_API_URL}pay-now-consumer-avm`;
  return axios.post(apiUrl, data);
}